import { render, staticRenderFns } from "./cowReproductiveStatus.vue?vue&type=template&id=8ec3c344&scoped=true&"
import script from "./cowReproductiveStatus.vue?vue&type=script&lang=js&"
export * from "./cowReproductiveStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec3c344",
  null
  
)

export default component.exports